import { render } from "./VoteSalesAnalytics.vue?vue&type=template&id=bc8d8b08&scoped=true"
import script from "./VoteSalesAnalytics.vue?vue&type=script&lang=js"
export * from "./VoteSalesAnalytics.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=bc8d8b08&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8d8b08"]])

export default __exports__